module.exports = __webpack_public_path__ + "static/nokia-hero-bbcb86d6cd2321ed4a7ac1bfa1c4dc92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/nokia/nokia-hero.jpg
// module id = 415
// module chunks = 168707334958949